import { FeatureFlag } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import {
  useRemoveConsultation,
  useReorderConsultation,
  useStaleConsultationDetection,
} from '@/entities/transcriptor';

import {
  useHideConsultation,
  useRestoreConsultation,
} from '@/features/hideConsultation';

import { type RecordingRowActions } from '../config';

// Shared by every list that renders recording rows (recordings page, patient
// profile timeline); only opening a recording is list-specific.
export const useRecordingRowActions = () => {
  const { isConsultationStale, forceStop } = useStaleConsultationDetection();

  const removeConsultation = useRemoveConsultation();
  const hideConsultation = useHideConsultation();
  const restoreConsultation = useRestoreConsultation();
  const reorderConsultation = useReorderConsultation();

  const hideMode = useAppSelector(
    organizationModel.selectors.selectFeatureFlag(
      FeatureFlag.FeatureFlag_Enable_ArchiveReports,
    ),
  );

  const actions: Omit<RecordingRowActions, 'onOpen'> = {
    onForceStop: forceStop,
    onArchive: hideConsultation,
    onDelete: removeConsultation,
    onReorder: reorderConsultation,
    onRestore: restoreConsultation,
  };

  return { actions, hideMode, isConsultationStale };
};
